import axios from 'axios'

export default {
    getCurrent() {
        return axios.get('/auth/me')
    },

    getUserCountryByCordinates(latitude, longitude) {
        const url = `https://nominatim.openstreetmap.org/reverse?format=json&lat=${latitude}&lon=${longitude}`
        return fetch(url)
            .then((response) => {
                return response.json()
            })
            .then((data) => {
                return data
            })
            .catch(() => {
                return
            })
    },

    getById(id) {
        return axios.get(`/user/find-user-by-id/${id}`)
    },
    getPublicById(id) {
        return axios.get(`/public-user/${id}`)
    },

    getOffers(id) {
        return axios.get(`/offer/user-offers/${id}`)
    },

    getUserbyEmail(email) {
        return axios.get(`/user/find-user-by-email/${email}`)
    },

    updateProfile(data) {
        return axios.put('/user', data)
    },

    changePassword(data) {
        return axios.put('/user/change-password', data)
    },

    changePhone(data) {
        return axios.put('/user/change-mobile', data)
    },

    verifyPhone(data) {
        return axios.put('/user/verify-change-mobile', data)
    },

    changeEmail(data) {
        return axios.put('/user/change-email', data)
    },

    addCredentials(data) {
        return axios.put('/user/add-credentials', data)
    },

    addPassword(data) {
        return axios.put('/user/add-password', data)
    },

    inviteUserToTheCompany({ email, companyId }) {
        return axios.post(
            '/user/invite-user-to-the-company',
            { email },
            {
                headers: {
                    'x-tenant-id': companyId,
                },
            },
        )
    },

    updateCompanyRole({ userId, companyRoleEnum, companyId, showOnPublicProfile, showPublicProfile }) {
        return axios.put(
            '/user/update-company-role',
            { userId, companyRoleEnum, showOnPublicProfile, showPublicProfile },
            {
                headers: {
                    'x-tenant-id': companyId,
                },
            },
        )
    },

    updateLanguage(data) {
        return axios.put('/user/update-language', data)
    },

    deleteUserFromTheCompany({ userId, companyId }) {
        return axios.delete(`/user/delete-user-from-the-company/${userId}`, {
            headers: {
                'x-tenant-id': companyId,
            },
        })
    },

    uploadProfilePhoto({ main, avatar }) {
        return axios.post('/photo/user', { main, avatar })
    },

    getUserAvailability() {
        return axios.get('/user-availability')
    },

    reuseAvailability(request) {
        return axios.post('/user-availability/reuse-availability', request)
    },

    getChartOfferData(request) {
        return axios.post('/statistics/user-calendar-events', request)
    },
    getChartRevenueData(request) {
        return axios.post('/statistics/user-calendar-events-revenue', request)
    },
    deleteUser() {
        return axios.delete('/auth/delete-user')
    },

    getLocations() {
        return axios.get('/location')
    },
}
